export default "__VITE_ASSET__cf106176__"